import axios from "axios";
import React, { useEffect, useState, useContext } from "react";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Form,
  Card,
} from "reactstrap";
import { toast } from "react-toastify";
//Radio button
import clsx from "clsx";
import { makeStyles } from "@material-ui/core/styles";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import { TextField } from "@material-ui/core";
import { Redirect, useHistory } from "react-router";
import Spinner from "../../sample/spinner";
import { UserContext } from "../../../context/UserContext";

const Quiz = () => {
  let history = useHistory();
  const context = useContext(UserContext);
  const useStyles = makeStyles({
    root: {
      "&:hover": {
        backgroundColor: "transparent",
      },
    },
    icon: {
      borderRadius: "50%",
      width: 16,
      height: 16,
      boxShadow:
        "inset 0 0 0 1px rgba(16,22,26,.2), inset 0 -1px 0 rgba(16,22,26,.1)",
      backgroundColor: "#f5f8fa",
      backgroundImage:
        "linear-gradient(180deg,hsla(0,0%,100%,.8),hsla(0,0%,100%,0))",
      "$root.Mui-focusVisible &": {
        outline: "2px auto rgba(19,124,189,.6)",
        outlineOffset: 2,
      },
      "input:hover ~ &": {
        backgroundColor: "#ebf1f5",
      },
      "input:disabled ~ &": {
        boxShadow: "none",
        background: "rgba(206,217,224,.5)",
      },
    },
    checkedIcon: {
      backgroundColor: "#137cbd",
      backgroundImage:
        "linear-gradient(180deg,hsla(0,0%,100%,.1),hsla(0,0%,100%,0))",
      "&:before": {
        display: "block",
        width: 16,
        height: 16,
        backgroundImage: "radial-gradient(#fff,#fff 28%,transparent 32%)",
        content: '""',
      },
      "input:hover ~ &": {
        backgroundColor: "#106ba3",
      },
    },
  });

  const [quizdata, setquizdata] = useState([]);
  const [result, setresult] = useState([]);
  const [FeedQuestion, setFeedQuestion] = useState([]);
  const [FeedQuestionAns, setFeedQuestionAns] = useState({});
  const [FeedQuestionTemp, setFeedQuestionTemp] = useState({});
  const [modal, setModal] = useState(false);
  const [Feedmodal, setFeedmodal] = useState(false);
  const [loading, setLoading] = useState(true);
  //   const [isSolved, setIsSolved] = useState(false);
  useEffect(() => {
    getAllQuiz();
  }, []);
  const getAllQuiz = async () => {
    let formData = new FormData();
    formData.append("cofflearn", localStorage.getItem("state"));
    axios
      .post("LearnerQuiz/getAllQuiz", formData)
      .then((res) => {
        // console.log(res.data);
        if (res.data.status === "200" || res.data.status === "100") {
          // console.log("i'm back");
          setLoading(false);
          setquizdata(res.data.examdata);
          return res;
        }
        throw res;
      })
      .catch((error) => {
        // console.log(error);
        toast.error("Please try again!!", {
          position: toast.POSITION.BOTTOM_LEFT,
        });
      });
  };
  const toggle = (item) => {
    setresult(item);
    setModal(!modal);
  };
  const getfeedback = (item) => {
    let formData = new FormData();
    formData.append("quizoff", item.quizoffid);
    formData.append("cofflearn", item.courseoffringlearner);
    axios
      .post("LearnerQuiz/getFeedBackQuestion", formData)
      .then((res) => {
        // console.log(res.data);
        if (res.data.status === "200" || res.data.status === "100") {
          // console.log(res.data);
          setFeedQuestionAns(null);
          setFeedQuestionTemp(null);
          setFeedQuestion(res.data);
          setFeedmodal(true);
          setFeedQuestionTemp(res.data.allques);
          for (var i = 0; i < res.data.subfeedquestion.length; i++) {
            setFeedQuestionAns((currentQuestions) => {
              return {
                ...currentQuestions,
                [res.data.subfeedquestion[i].feedbackQuestionid]: "",
              };
            });
          }
          return res;
        }
        throw res;
      })
      .catch((error) => {
        toast.error("Please try again!!", {
          position: toast.POSITION.BOTTOM_LEFT,
        });
      });
  };
  const addtofeedback = (option, quesion) => {
    setFeedQuestionAns((currentQuestions) => {
      // console.log(currentQuestions);
      return { ...currentQuestions, [quesion]: option };
    });
    // console.log(FeedQuestionAns);
  };
  const addsubtofeedback = (option, quesion) => {
    if (option.length <= 150) {
      setFeedQuestionAns((currentQuestions) => {
        return { ...currentQuestions, [quesion]: option };
      });
    } else {
      toast.error("Please Enter description less than 150 character's", {
        position: toast.POSITION.BOTTOM_LEFT,
      });
    }
    // console.log(FeedQuestionAns);
  };
  const savefeedback = (cofflearn, quizOffering) => {
    // console.log(FeedQuestionAns);
    var finalvar = false;
    let formData = new FormData();
    let breakCondition = false;
    for (var i = 0; i < FeedQuestion?.subfeedquestion?.length; i++) {
      if (
        FeedQuestionAns &&
        FeedQuestionAns[FeedQuestion?.subfeedquestion[i].feedbackQuestionid]
      ) {
        if (
          FeedQuestionAns[
            FeedQuestion?.subfeedquestion[i].feedbackQuestionid
          ].trim().length < 15
        ) {
          // console.log([FeedQuestion?.subfeedquestion[i].feedbackQuestionid])
          // console.log(FeedQuestionAns[FeedQuestion?.subfeedquestion[i].feedbackQuestionid].trim())
          toast.error("Please Enter description more than 15 character's");
          setFeedQuestionAns((currentQuestions) => {
            return { ...currentQuestions, [FeedQuestion?.subfeedquestion[i].feedbackQuestionid]: FeedQuestionAns[FeedQuestion?.subfeedquestion[i].feedbackQuestionid].trim() };
          });
          return;
        } else if (
          FeedQuestionAns[FeedQuestion?.subfeedquestion[i].feedbackQuestionid]
            .length > 150
        ) {
          toast.error("Please Enter description less than 150 character's");
          return;
        }
      }
    }
    FeedQuestionTemp.map((itemn, indexitemn) => {
      if (FeedQuestionAns && !breakCondition) {
        if (FeedQuestionAns[itemn] && FeedQuestionAns[itemn] !== " ") {
          formData.append(itemn, FeedQuestionAns[itemn]);
          finalvar = true;
        } else {
          // setIsSolved(false)
          finalvar = false;
          breakCondition = true;
          return;
        }
      } else {
        // setIsSolved(false)
        finalvar = false;
        return;
      }
    });
    if (!finalvar) {
      toast.error("please give valid feedback for all question!!", {
        position: toast.POSITION.BOTTOM_LEFT,
      });
      return;
    }
    // console.log("in final loop");
    // console.log("print formdata"+formadata)
    formData.append("cofflearn", cofflearn);
    formData.append("quizoff", quizOffering);
    // formData.append("cofflearn",localStorage.getItem("state"))
    axios
      .post("LearnerQuiz/saveFeedBackQuestion", formData)
      .then((res) => {
        if (res.data.status === "200" || res.data.status === "100") {
          // console.log("i'm back3");
          history.push({
            pathname: "/StartExam",
            state: {
              quizoffid: res.data.quizoffid,
              courseoffringlearner: res.data.col,
            },
          });
          return res;
        }
        throw res;
      })
      .catch((error) => {
        toast.error("Please try again!!", {
          position: toast.POSITION.BOTTOM_LEFT,
        });
      });
  };
  function StyledRadio(props) {
    const classes = useStyles();

    return (
      <Radio
        className={classes.root}
        disableRipple
        color="default"
        checkedIcon={
          <span className={clsx(classes.icon, classes.checkedIcon)} />
        }
        icon={<span className={classes.icon} />}
        {...props}
      />
    );
  }
  if (!context?.user?.email) {
    return <Redirect to="/" />;
  }
  return (
    <div>
      <Card className="bg-color-tab">
        <br />
        {loading ? (
          <Spinner />
        ) : (
          <>
            {quizdata.length > 0 ? (
              <>
                <div class="table-responsive p-3">
                  <table class="table table-striped table-hover bg-white">
                    <thead>
                      <tr class="text-center table-tr-color">
                        <th>Sr.no</th>
                        <th>Exam</th>
                        <th>Start Date </th>
                        <th>End Date </th>
                        <th>Start Time </th>
                        <th>End Time </th>
                        <th>Status</th>
                      </tr>
                    </thead>
                    <tbody class="content-size">
                      {quizdata.map((item, indexitem) => (
                        <>
                          <tr>
                            <td>
                              <span class="step">{indexitem + 1}</span>
                            </td>
                            <td>{item.title}</td>
                            <td>{item.start_date}</td>
                            <td>{item.end_date}</td>
                            <td>{item.start_time}</td>
                            <td>{item.end_time}</td>
                            <td>
                              {item.status === "Result" ? (
                                <>
                                  <Button
                                    className="rounded-pill"
                                    color="primary"
                                    onClick={(e) => toggle(item)}
                                  >
                                    Result
                                  </Button>
                                </>
                              ) : item.status === "Online Exam" ? (
                                <>
                                  {item.feedback === true ? (
                                    item.learnfeedback === false ? (
                                      <Button
                                        color="success"
                                        className="rounded-pill"
                                        onClick={(e) => getfeedback(item)}
                                      >
                                        Start Exam
                                      </Button>
                                    ) : (
                                      <Button
                                        color="success"
                                        className="rounded-pill"
                                        onClick={() =>
                                          history.push({
                                            pathname: "/StartExam",
                                            state: {
                                              quizoffid: item.quizoffid,
                                              courseoffringlearner:
                                                item.courseoffringlearner,
                                            },
                                          })
                                        }
                                      >
                                        Start Exam
                                      </Button>
                                    )
                                  ) : (
                                    <Button
                                      color="success"
                                      className="rounded-pill"
                                      onClick={() =>
                                        history.push({
                                          pathname: "/StartExam",
                                          state: {
                                            quizoffid: item.quizoffid,
                                            courseoffringlearner:
                                              item.courseoffringlearner,
                                          },
                                        })
                                      }
                                    >
                                      Start Exam
                                    </Button>
                                  )}
                                </>
                              ) : (
                                <Button
                                  color="danger"
                                  className="rounded-pill"
                                  disabled
                                >
                                  Exam Not Started
                                </Button>
                              )}
                            </td>
                          </tr>
                        </>
                      ))}
                    </tbody>
                  </table>
                </div>
                <Modal isOpen={modal} toggle={toggle}>
                  <ModalHeader toggle={() => setModal(!modal)}>
                    Result
                  </ModalHeader>
                  <ModalBody>
                    {result.learnerQuizFinalSubmission === "no" ? (
                      <>
                        <h4 style={{ color: "red" }}>
                          You have not given Exam
                        </h4>
                      </>
                    ) : (
                      <>
                        <div class="table-responsive">
                          <div class="card">
                            <table class="table">
                              <thead>
                                <th>Question Type</th>
                                <th>Total Question</th>
                                <th>Marks Obtain</th>
                                <th>OutOf Marks</th>
                              </thead>
                              <tbody>
                                {result.totalquestion ? (
                                  <tr>
                                    <td>MCQ</td>
                                    <td>{result.totalquestion}</td>
                                    <td>{result.actualmarks}</td>
                                    <td>{result.total}</td>
                                  </tr>
                                ) : (
                                  ""
                                )}
                                {result.stotalquestion ? (
                                  <>
                                    {" "}
                                    <tr>
                                      <td>Subjective</td>
                                      <td>{result.stotalquestion}</td>
                                      <td>{result.sactualmarks}</td>
                                      <td>{result.stotal}</td>
                                    </tr>
                                  </>
                                ) : (
                                  ""
                                )}
                                <tr>
                                  <td
                                    colSpan="3"
                                    style={{ textAlign: "right" }}
                                  >
                                    <b>Obtain Marks</b>
                                  </td>
                                  <td>
                                    {result.sactualmarks + result.actualmarks}
                                  </td>
                                </tr>
                                <tr>
                                  <td
                                    colSpan="3"
                                    style={{ textAlign: "right" }}
                                  >
                                    <b>Out Of</b>
                                  </td>
                                  <td>{result.total + result.stotal}</td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                        <b style={{ float: "right", color: "red" }}>
                          Subjective Marks will be updated after Evaluation*
                        </b>
                      </>
                    )}
                  </ModalBody>
                  <ModalFooter>
                    <Button color="danger" onClick={() => setModal(!modal)}>
                      Close
                    </Button>
                  </ModalFooter>
                </Modal>
                <Modal
                  isOpen={Feedmodal}
                  toggle={() => setFeedmodal(!Feedmodal)}
                >
                  <ModalHeader toggle={() => setFeedmodal(!Feedmodal)}>
                    Feedback
                  </ModalHeader>
                  <ModalBody>
                    <Form>
                      {FeedQuestion?.feedquestion?.map((obj, index) => (
                        <>
                          {index + 1}) {obj.feedbackQuestion}
                          <br />
                          <RadioGroup
                            row
                            name={obj.feedbackQuestionid + ""}
                            required
                          >
                            {obj.feedbackQuestionOption.map((option, index) => (
                              <>
                                <FormControlLabel
                                  value={option.feedbackQuestionOptionname}
                                  control={<StyledRadio />}
                                  label={option.feedbackQuestionOptionname}
                                  name={option.feedbackQuestionOptionid}
                                  id={option.feedbackQuestionOptionid}
                                  onChange={(e) =>
                                    addtofeedback(
                                      option.feedbackQuestionOptionid,
                                      obj.feedbackQuestionid
                                    )
                                  }
                                />
                              </>
                            ))}
                          </RadioGroup>
                        </>
                      ))}
                      {FeedQuestion?.subfeedquestion?.map((subj, index) => (
                        <>
                          {index + FeedQuestion?.feedquestion.length + 1}){" "}
                          {subj.feedbackQuestion}
                          <br />
                          <TextField
                            name="description"
                            id="description"
                            style={{ width: "100%" }}
                            label="Description"
                            multiline
                            value={
                              FeedQuestionAns
                                ? FeedQuestionAns[subj.feedbackQuestionid]
                                  ? FeedQuestionAns[subj.feedbackQuestionid]
                                  : ""
                                : ""
                            }
                            onChange={(e) =>
                              addsubtofeedback(
                                e.target.value,
                                subj.feedbackQuestionid
                              )
                            }
                          />
                          <p className="text-right">
                            {FeedQuestionAns
                              ? FeedQuestionAns[subj.feedbackQuestionid]
                                ? FeedQuestionAns[subj.feedbackQuestionid]
                                    .length
                                : "0"
                              : "0"}
                            /150
                          </p>
                        </>
                      ))}
                      <br />
                      <Button
                        color="primary"
                        onClick={(e) =>
                          savefeedback(
                            FeedQuestion?.cofflearn,
                            FeedQuestion.quizOffering
                          )
                        }
                      >
                        Save Feedback
                      </Button>
                    </Form>
                  </ModalBody>
                  <ModalFooter>
                    <Button
                      color="danger"
                      onClick={() => setFeedmodal(!Feedmodal)}
                    >
                      Close
                    </Button>
                  </ModalFooter>
                </Modal>
              </>
            ) : (
              // <Spinner />
              <center>
                <br /> <br />
                <img
                  dir="images"
                  src="/assets/images/nomcq.svg"
                  alt=""
                  width="300"
                  height="150"
                  className="img-thumbnail"
                />
                <br />
                <br />
                <h6>"Hooray! No Quiz!"</h6>
              </center>
            )}
          </>
        )}
      </Card>
    </div>
  );
};

export default Quiz;
